export default "__VITE_ASSET__BLChAQ2c__"